import { mapGetters } from 'vuex'
import { getUploadConfig } from '@/utils/upload'
import journal from '@/api/journal'
import operation from '@/api/operation'
import special, { specialApply } from '@/api/special'
import CreatePNG from '@/components/createPNG.dialog.vue'
import Add from './add.dialog.vue'
import AddPlannedPaper from './addPlannedPaper.dialog.vue'
import SendEmail from '@/views/editorial-office/manuscripts/dialog/send-email.dialog'
import section from '@/api/section'
import help from '@/utils/help'

const guestEditorColumns = [
  {
    title: '',
    enTitle: 'Name',
    width: 200,
    dataIndex: 'name',
    slot: 'name',
  },
  {
    title: '',
    enTitle: 'Email',
    width: 150,
    dataIndex: 'email',
    slot: 'omis',
  },
  {
    title: '',
    enTitle: 'Affiliations',
    width: 300,
    dataIndex: 'affiliation',
    slot: 'omis',
  },
  {
    title: '',
    enTitle: 'ORCID',
    width: 150,
    dataIndex: 'orcid',
  },
  {
    title: '',
    enTitle: 'ResearchGate Account',
    width: 180,
    dataIndex: 'researchGate',
    slot: 'omis',
  },
  {
    title: '',
    enTitle: 'CV',
    width: 100,
    dataIndex: 'cv',
    slot: 'link',
  },
  {
    title: '',
    enTitle: 'Reviewed Journal',
    width: 150,
    dataIndex: 'reviewJournal',
    slot: 'omis',
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 120,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions',
  },
]
const plannedPaperColumns = [
  {
    title: '',
    enTitle: 'Name',
    width: 150,
    dataIndex: 'nameText',
    slot: 'omission',
  },
  {
    title: '',
    enTitle: 'Email',
    width: 150,
    dataIndex: 'email',
    slot: 'omis',
  },
  {
    title: '',
    enTitle: 'Affiliations',
    width: 300,
    dataIndex: 'affiliation',
    slot: 'omission',
  },
  {
    title: '',
    enTitle: 'Title',
    width: 300,
    dataIndex: 'titleText',
    slot: 'omission',
  },
  {
    title: '',
    enTitle: 'Abstract',
    width: 300,
    dataIndex: 'summaryText',
    slot: 'omission',
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 120,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions',
  },
]
export default {
  components: {
    Add,
    AddPlannedPaper,
    SendEmail,
    CreatePNG,
  },
  data() {
    return {
      guestEditorColumns,
      plannedPaperColumns,
      isVisable: false,
      isVisablePlannedPaper: false,
      showSendEmail: false,
      isApp: false,
      journalList: [],
      rules: {},
      params: {
        journalId: '',
        editorList: [],
        particleList: [],
        keywords: [],
        showed: false,
      },
      guestEditorEmail: '',
      inputData: {},
      categoryList: [],
      pdfType: 'ge-c',
      isVisablePDF: false,
      oldData: {},
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      domain: 'getDomain',
      country: 'getCountry',
      user: 'getUser',
    }),
  },
  async mounted() {
    this.params.journalId = this.$route.query.journalId
    this.isApp = !!this.$route.path.includes('/application/')
    const id = this.$route.params.id
    if (id) {
      this.getQuery(id)
    }
    this.getJournal()
    this.getRules()
    this.getSection()
    help.closeAutocomplete()
  },
  methods: {
    async getQuery(id) {
      this.params = this.isApp
        ? await specialApply.query(id)
        : await special.query(id)
      this.oldData = JSON.parse(JSON.stringify(this.params))
      this.$set(
        this.params,
        'keywords',
        this.params.keyword ? this.params.keyword.split(';') : []
      )
      this.params.journalId =
        this.params.journalId || this.$route.query.journalId
    },
    async getJournal() {
      this.journalList = await journal.userGet()
    },
    async getSection() {
      this.categoryList = await section.getAll({
        journalId: this.params.journalId,
      })
      this.categoryList.unshift({
        name: 'Select Section',
        id: '',
      })
    },
    async handleUpload(key, files) {
      const file = files[0]
      const pdfFiles = ['flyer']
      const pdfTypes = ['application/pdf']
      let rightType = true
      if (pdfFiles.includes(key)) {
        rightType = pdfTypes.includes(file.type)
      }
      if (!rightType) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].isWrongType,
        })
        return false
      }
      let MS = 2
      if (key === 'flyer') {
        MS = 10
      }
      const maxSize = file.size / 1024 / 1024 < MS
      if (!maxSize) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].notExceed + MS + 'MB',
        })
        return false
      }
      const url = await getUploadConfig(file, `${this.publisherId}/file`)

      if (url.includes('err:')) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].uploadFileFail,
        })
        return false
      }

      this.$set(this.params, key, url)
      this.$set(this.params, key + 'Name', file.name)
    },

    delFile(key) {
      this.params[key] = ''
      this.params[key + 'Name'] = ''
    },

    goToPage(val, name) {
      help.download(val, name)
    },

    async addGuestEditor() {
      let flag = false
      if (this.guestEditorEmail) {
        const res = await special.geditorSearch(this.guestEditorEmail)
        if (res && res.id) {
          const f = this.params.editorList.some((item) => {
            return item.email === res.email
          })
          if (!f) {
            // this.params.editorList.push(res)
            this.inputData = Object.assign(
              {
                journalId: this.params.journalId,
                index: this.params.editorList.length,
              },
              res
            )
            this.isVisable = true
          } else {
            this.$message.error({
              title: 'Error',
              content:
                'The guest editor already exists, please do not add it again！',
            })
          }
        } else {
          this.$message.error({
            title: 'Error',
            content: 'The mailbox was not searched',
          })
          flag = true
        }
        this.guestEditorEmail = ''
      } else {
        flag = true
      }
      if (flag) {
        this.inputData = {
          journalId: this.params.journalId,
          email: this.guestEditorEmail,
          index: this.params.editorList.length,
        }
        this.isVisable = true
      }
    },
    editGuestEditor(val, index) {
      val.index = index
      val.journalId = this.params.journalId
      this.inputData = val
      this.isVisable = true
    },
    delGuestEditor(index) {
      this.params.editorList.splice(index, 1)
    },
    addPlannedPaper() {
      this.inputData = {
        index: this.params.particleList.length,
      }
      this.isVisablePlannedPaper = true
    },
    editPlannedPaper(val, index) {
      val.index = index
      this.inputData = val
      this.isVisablePlannedPaper = true
    },
    delPlannedPaper(index) {
      this.params.particleList.splice(index, 1)
    },
    confirm(val) {
      const flag = this.params.editorList.some((item, index) => {
        if (
          index !== val.index &&
          item.email &&
          item.email.toLowerCase() === val.email.toLowerCase()
        ) {
          return true
        }
      })
      if (flag) {
        this.$message.error({
          title: 'Error',
          content:
            'The guest editor already exists, please do not add it again！',
        })
        return
      }
      this.isVisable = false
      this.$set(this.params.editorList, val.index, val)
    },
    confirmPlannedPaper(val) {
      this.isVisablePlannedPaper = false
      this.$set(this.params.particleList, val.index, val)
    },
    cancel() {
      this.isVisable = false
      this.isVisablePlannedPaper = false
      this.isVisablePDF = false
    },
    async save(handle = '') {
      const flag = this.$refs['special-issue-add-form'].validate()
      if (!flag) {
        return
      }
      this.params.keyword = this.params.keywords
        ? this.params.keywords.join(';')
        : ''
      // if (!this.params.editorList.length) {
      //   this.$message.error({
      //     title: 'Error',
      //     content: 'Guest Editor' + this.LANGUAGE[this.language].noEmpty
      //   })
      //   return
      // }
      if (this.params.id) {
        if (this.isApp) {
          this.params.handle = handle || 'UNHANDLED'
          await specialApply.edit(this.params.id, this.params)
          if (handle === 'ACCEPTED') {
            await operation.add({
              authorityCode: 'WEBSITE.SPECIAL_ISSUES.APPLY.ACCEPT',
              type: 'ACCEPT',
              info: `Special Issue's Application - Accept: ${this.params.title} `,
              detail: `【Title】: ${this.params.title}`,
            })
          } else if (handle === 'REFUSED') {
            await operation.add({
              authorityCode: 'WEBSITE.SPECIAL_ISSUES.APPLY.REFUSE',
              type: 'REFUSE',
              info: `Special Issue's Application - Refuse: ${this.params.title} `,
              detail: `【Title】: ${this.params.title}`,
            })
          }
        } else {
          const res = await special.edit(this.params.id, this.params)
          this.oldData.editorList.forEach((item) => {
            delete item.version
          })
          res.editorList.forEach((item) => {
            delete item.version
          })
          const keys = {
            sort: `【Hierarchy】: Change from 【${this.oldData.sort}】 to 【${res.sort}】;`,
            code: `【Website Abbreviation】: Change from 【${this.oldData.code}】 to 【${res.code}】;`,
            startTime: `【Start Time】: Change from 【${
              this.oldData.startTime &&
              this.$moment(this.oldData.startTime).format('DD / MM / YYYY')
            }】 to 【${
              res.startTime &&
              this.$moment(res.startTime).format('DD / MM / YYYY')
            }】;`,
            endTime: `【End Time】: Change from 【${
              this.oldData.endTime &&
              this.$moment(this.oldData.endTime).format('DD / MM / YYYY')
            }】 to 【${
              res.endTime && this.$moment(res.endTime).format('DD / MM / YYYY')
            }】;`,
            title: `【Title】: Changed;`,
            summary: `【Special Issue Information】: Changed;`,
            sectionId: `【Section】Changed;`,
            keyword: `【Keywords】Changed;`,
            flyer: `【Special Issue Flyer】Changed;`,
            editorList: `【Guest Editor】: Changed;`,
          }
          let detail = ``
          Object.keys(keys).forEach((key) => {
            if (JSON.stringify(this.oldData[key]) != JSON.stringify(res[key])) {
              detail += keys[key] + '<br/>'
            }
          })
          if (detail) {
            await operation.add({
              authorityCode: 'WEBSITE.SPECIAL_ISSUES.EDIT',
              type: 'EDIT',
              info: `Edit The Special Issue: ${res.code} `,
              detail,
            })
          }
        }
        this.$message.success({
          title: 'Success',
          content: `The Special Issue has been ${
            handle.toLowerCase() || 'saved'
          }!`,
        })
        this.$router.back(-1)
      } else {
        this.$confirm({
          title: 'Reminder',
          content:
            'Please add GE to the yellow list of <a class="link-color" href="https://www.hydoffice.com:7758/#/access/login" target="_blank">Digital Office Center</a>！When finished, please click Confirm.',
          type: 'warning',
          icon: 'iconDetails',
          confirmText: 'Confirm',
        }).then(async () => {
          this.params.released = !!handle
          await special.add(this.params)
          await operation.add({
            authorityCode: 'WEBSITE.SPECIAL_ISSUES.CREATE_NEW',
            type: 'ADD',
            info: `Add Special Issue : ${this.params.code} `,
            detail: `【Website Abbreviation】: ${this.params.code}<br/>
        【End Time】: ${
          this.params.endTime
            ? this.$moment(this.params.endTime).format('DD / MM / YYYY')
            : ''
        }  `,
          })
          if (handle) {
            await operation.add({
              authorityCode: 'WEBSITE.SPECIAL_ISSUES.PUBLISH',
              type: 'PUBLISH',
              info: `Publish/Unpublish: ${this.params.code}`,
              detail: `Change from 【Unpublish】 to 【Publish】`,
            })
          }
          this.$message.success({
            title: 'Success',
            content: `The Special Issue has been ${
              handle.toLowerCase() || 'saved'
            }!`,
          })
          this.$router.back(-1)
        })
      }

      // if (handle !== 'ACCEPTED') {
      // this.$router.back(-1)
      // }
    },
    cancelMail() {
      this.showSendEmail = false
      setTimeout(() => {
        this.$router.back(-1)
      }, 500)
    },
    async reject() {
      this.$confirm({
        title: 'Are you sure you want to reject this application?',
        content:
          'Please be aware of once this application is rejected, the candidate will receive an notification email.',
        type: 'danger',
        icon: 'iconDetails',
        confirmText: 'Reject',
      }).then(async () => {
        this.save('REFUSED')
      })
    },
    async accept() {
      this.$confirm({
        title: 'Are you sure you want to accept this application?',
        content:
          'Please be aware of once this application is accepted, the candidate will receive an notification email.',
        type: 'success',
      }).then(async () => {
        this.save('ACCEPTED')
        // this.sendEmail()
      })
    },
    // 发送邮件
    sendEmail() {
      this.inputData = {
        applySpecialId: this.params.id,
      }
      this.showSendEmail = true
    },
    getRules() {
      this.rules = {
        title: [
          {
            required: true,
            message:
              'Special Issue Title' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        endTime: [
          {
            required: true,
            message: 'End Time' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
      }
      if (!this.isApp) {
        this.rules.code = [
          {
            required: true,
            message:
              'Website Abbreviation' + this.LANGUAGE[this.language].noEmpty,
          },
        ]
      }
    },
    createCanvans(val, type) {
      this.inputData = val
      this.inputData.specialTitle = this.params.title
      this.pdfType = type
      this.isVisablePDF = true
    },
    setSort(val, key) {
      val.forEach((item, index) => {
        item.sort = index + 1
      })
      this.params[key] = val
    },
  },
}
